import {
    patchState,
    signalStore,
    withMethods,
    withState,
  } from '@ngrx/signals';
  import { QuarterlyReports, quarterlyReportsInitialState } from './quarterly-reports.model';

export const QuarterlyReportsStore = signalStore(
  withState(quarterlyReportsInitialState),

  withMethods(({...store}) => ({
      setQuarterCourseRegistration(quarterCourseRegistrationSignal: QuarterlyReports["quarterCourseRegistrationSignal"]) {
        patchState(store, {quarterCourseRegistrationSignal});
      },
      setTotalCourseRegistration(totalCourseRegistrationSignal: QuarterlyReports["totalCourseRegistrationSignal"]) {
        patchState(store, {totalCourseRegistrationSignal});
      },
      setQuarterCourseCertificate(quarterCourseCertificateSignal: QuarterlyReports["quarterCourseCertificateSignal"]) {
        patchState(store, {quarterCourseCertificateSignal});
      },
      setTotalCourseCertificate(totalCourseCertificateSignal: QuarterlyReports["totalCourseCertificateSignal"]) {
        patchState(store, {totalCourseCertificateSignal});
      },
      setTopOrganizations(topOrganizationsSignal: QuarterlyReports["topOrganizationsSignal"]) {
        patchState(store, {topOrganizationsSignal});
      },
      setTopDomains(topDomainsSignal: QuarterlyReports["topDomainsSignal"]) {
        patchState(store, {topDomainsSignal});
      },
      setAccountMetrics(accountMetricsSignal: QuarterlyReports["accountMetricsSignal"]) {
        patchState(store, {accountMetricsSignal});
      },
      setWebsiteAnalytics(websiteAnalyticsSignal: QuarterlyReports["websiteAnalyticsSignal"]) {
        patchState(store, {websiteAnalyticsSignal});
      },
      setQuarterCourseRegistrationLoading(isLoading: boolean) {
        patchState(store, {loadingQuarterCourseRegistrationSignal: isLoading});
      },
      setTotalCourseRegistrationLoading(isLoading: boolean) {
        patchState(store, {loadingTotalCourseRegistrationSignal: isLoading});
      },
      setQuarterCourseCertificateLoading(isLoading: boolean) {
        patchState(store, {loadingQuarterCourseCertificateSignal: isLoading});
      },
      setTotalCourseCertificateLoading(isLoading: boolean) {
        patchState(store, {loadingTotalCourseCertificateSignal: isLoading});
      },
      setTopOrganizationsLoading(isLoading: boolean) {
        patchState(store, {loadingTopOrganizationsSignal: isLoading});
      },
      setTopDomainsLoading(isLoading: boolean) {
        patchState(store, {loadingTopDomainsSignal: isLoading});
      },
      setAccountMetricsLoading(isLoading: boolean) {
        patchState(store, {loadingAccountMetricsSignal: isLoading});
      },
      setWebsiteAnalyticsLoading(isLoading: boolean) {
        patchState(store, {loadingWebsiteAnalyticsSignal: isLoading});
      },
      resetStore() {
        patchState(store, quarterlyReportsInitialState );
      }
  }))
);
